/**
 * Dev-only console logger. Scanner and OCR paths log heavily (candidate VINs,
 * frame timings) which is what makes them debuggable on a real device, but that
 * output must not reach production — an OCR line can carry a VIN, and a VIN
 * identifies a specific vehicle. `error` always emits; `log`/`warn` are gated.
 */
const enabled = __DEV__;

export const logger = {
  log: (...args: unknown[]) => {
    if (enabled) console.log(...args);
  },
  warn: (...args: unknown[]) => {
    if (enabled) console.warn(...args);
  },
  error: (...args: unknown[]) => {
    console.error(...args);
  },
};
